module.exports = __webpack_public_path__ + "static/media/gitLogo.dc89f8fc.png";